import { useTranslation } from "react-i18next";
import type { LdSuccessionCandidate } from "../../lib/api";

/** Pills, heat scales and the succession row shared by the L&D screens. Lifted out of the single roadmap page
 * when it became five screens, so the colour scales stay identical rather than drifting apart. */

export const PHASE_PILL: Record<string, string> = {
  Completed: "bg-green-50 text-status-green border-status-green/40",
  "In Progress": "bg-blue-50 text-brand-primary border-brand-primary/40",
  Planned: "bg-brand-grey-light text-brand-charcoal border-brand-grey-light",
  "On Hold": "bg-amber-50 text-status-amber border-status-amber/40",
};
export const CERT_PILL: Record<string, string> = {
  Expired: "bg-red-50 text-status-red border-status-red/40",
  Expiring: "bg-amber-50 text-status-amber border-status-amber/40",
  Valid: "bg-green-50 text-status-green border-status-green/40",
  Missing: "bg-brand-grey-light text-brand-charcoal border-brand-grey-light",
};
export const BAND_PILL: Record<string, string> = {
  "Ready now": "bg-green-50 text-status-green border-status-green/40",
  "Ready soon": "bg-amber-50 text-status-amber border-status-amber/40",
  "Development needed": "bg-brand-grey-light text-brand-charcoal border-brand-grey-light",
};

export const heat = (avg: number) => (avg >= 0.8 ? "bg-green-100 text-green-900" : avg >= 0.6 ? "bg-green-50 text-green-800" : avg >= 0.4 ? "bg-amber-50 text-amber-800" : "bg-red-50 text-red-800");
export const coverageHeat = (pct: number) => (pct >= 80 ? "text-status-green" : pct >= 50 ? "text-status-amber" : "text-status-red");

export const INDUCTION_PROGRAM = "Standardised Induction";
export const HS_PROGRAM = "Health & Safety Base";
export const OJT_PROGRAM = "OJT critical lines (extrusion, compression)";

export function SuccessionCandidateRow({ c }: { c: LdSuccessionCandidate }) {
  const { t } = useTranslation();
  return (
    <tr className="border-t border-brand-grey-light/70">
      <td className="py-1 pr-3"><div className="font-semibold">{c.employee_name}</div><div className="text-[11px] text-brand-grey">{c.designation} · {c.company}</div></td>
      <td className={`py-1 pr-3 text-right font-semibold tabular-nums ${coverageHeat(c.gap.coverage_pct)}`}>{c.gap.coverage_pct} %</td>
      <td className="py-1 pr-3"><span className={`rounded border px-2 py-0.5 text-[11px] font-semibold ${BAND_PILL[c.band]}`}>{t(`ld.succession.band.${c.band}`, c.band)}</span></td>
    </tr>
  );
}
